let bound = false

export const initBackofficeEditionSwitcher = () => {
  if (bound) return
  bound = true

  document.addEventListener("click", (event) => {
    document.querySelectorAll("[data-edition-switcher], [data-account-menu]").forEach((details) => {
      if (!details.open) return
      if (details.contains(event.target)) return
      details.open = false
    })
  })
}
